import { render, staticRenderFns } from "./CampusMostrar.vue?vue&type=template&id=ada69cf4"
import script from "./CampusMostrar.vue?vue&type=script&lang=js"
export * from "./CampusMostrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports